// extracted by mini-css-extract-plugin
module.exports = {"icons":"storyPageMetaDataIcons-m__icons__3E4Xg","share-button":"storyPageMetaDataIcons-m__share-button__1NXgK"};